<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Shopping Cart Management</h4>
        </div>

    </div>
</div>

<div style="display: block;Width:12%;margin-left: 30px;" *ngIf="write==true">
    <div class="mt-3" >
        <a *ngIf="!show" href="javascript:void(0)" (click)="addShoppingCart()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addShoppingCart()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </div>
</div>

<div *ngIf="show">
    <div>

        <div class="container-fluid" style="margin-top: -19px;">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #shoppingCart="ngForm" novalidate>
                                <div class="form-body">
                                    <h3 class="card-title">Add Shopping Cart</h3>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span> Account
                                                    Id
                                                </label>
                                                <select class="form-control" required #accountId="ngModel"
                                                    name="accountId" [(ngModel)]="shoppingCartAddObj.accountId"
                                                    data-placeholder="Choose a Role Name" tabindex="1" 
                                                    (change)="getByCurrentInventoryStatusandEmailID(shoppingCartAddObj.accountId)">
                                                    <option disabled="" value="" selected>Account Id</option>

                                                    <option *ngFor="let ual of userAccountsList"
                                                        value="{{ual._id}}">
                                                        {{ual.emailAddress}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!accountId.errors.required"
                                                    *ngIf="accountId.errors && (accountId.touched || accountId.dirty)">*Please
                                                    select Account Id
                                                </span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span> Product

                                                </label>
                                                <select class="form-control" required #productId="ngModel"
                                                    name="productId" [(ngModel)]="shoppingCartAddObj.productId"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Product Id</option>

                                                    <option *ngFor="let cil of currentInventoryList"
                                                        value="{{cil.productId}}">
                                                        {{cil.productName}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!productId.errors.required"
                                                    *ngIf="productId.errors && (productId.touched || productId.dirty)">*Please
                                                    select Product Id
                                                </span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Required
                                                    Quantity
                                                </label>
                                                <input type="text" id="requiredQuantity" class="form-control" required
                                                    maxlength="30" #requiredQuantity="ngModel" name="requiredQuantity"
                                                    [(ngModel)]="shoppingCartAddObj.requiredQuantity"   
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"

                                                    placeholder="requiredQuantity" maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!requiredQuantity.errors.required"
                                                    *ngIf="requiredQuantity.errors && (requiredQuantity.touched || requiredQuantity.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Planned
                                                    Purchase
                                                    Date
                                                </label>
                                                <input type="date" id="plannedPurchasedate" class="form-control"
                                                    required minlength="3" maxlength="30" #plannedPurchasedate="ngModel" [min]="minDate | date:'yyyy-MM-dd'"
                                                    name="plannedPurchasedate" 
                                                    [(ngModel)]="shoppingCartAddObj.plannedPurchasedate"
                                                    placeholder="Select Date" maxlength="40">
                                                    
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!plannedPurchasedate.errors.required"
                                                    *ngIf="plannedPurchasedate.errors && (plannedPurchasedate.touched || plannedPurchasedate.dirty)">
                                                    *This Field is Required</span>

                                            </div>
                                        </div>

                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                </div>

                                <!--/row-->






                                <div class="form-actions m-t-40" *ngIf="export==true">
                                    <button type="submit" style="background-color: #353556;color:white" class="btn"
                                        (click)="saveShoppingCart()" [disabled]="!shoppingCart.valid">
                                        <i class="fa fa-check"></i> Submit</button> &nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addShoppingCart()"
                                        data-dismiss="modal">Cancel</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
    </div>
</div>
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <div class="row">
                                <div class="col-md-10">
                                    <label> Shopping cart Management</label>
                                </div>

                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>
                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter" *ngIf="export==true">
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </div>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    
                                    <input type="radio" id="emailId" name="gender" style="margin-top: 29px;" [(ngModel)]="filterValueSelected"
                                        value="ei" (change)="applyCustomizedFilter()"> Account Email Id &nbsp;&nbsp;
                                        <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pi" (change)="applyCustomizedFilter()"> Product Id &nbsp;&nbsp;
                                    <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pn" (change)="applyCustomizedFilter()"> Product Name &nbsp;&nbsp;
                                    <input type="radio" id="preferedvendorid" name="gender"
                                        [(ngModel)]="filterValueSelected" value="pvn"
                                        (change)="applyCustomizedFilter()">Preferred Vendor &nbsp;&nbsp;
                                        


                                </div>
                                <div style="margin-left: 820px">

                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>



                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                       
                                         <ng-container matColumnDef="AccountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Email Id</th>
                                            <td *matCellDef="let row">
                                               {{row.AccountEmailId}}
                                            </td>
                                        </ng-container>
                                       <ng-container matColumnDef="_id">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cart Id</th>
                                            <td *matCellDef="let row">
                                                {{row._id}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="ProductId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Id</th>
                                            <td *matCellDef="let row">
                                                {{row.ProductId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="ProductName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                                            <td *matCellDef="let row">
                                                {{row.ProductName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productImage">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Image</th>
                                            <td *matCellDef="let row" style="white-space: nowrap;">
                                              
                                                <button class="dropdown-item" data-toggle="modal"
                                                data-target="#responsiveImages" style="color:rgb(30, 110, 124)" (click)="viewImages(row.productId)">
                                               View
                                                </button>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Description">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Description
                                            </th>
                                            <td *matCellDef="let row">
                                               {{row.Description}}

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="RequiredQuantity">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Required Quantity</th>
                                            <td *matCellDef="let row">
                                               {{row.RequiredQuantity}}
                                            </td>
                                        </ng-container>
                                       
                                        <ng-container matColumnDef="StockUnit">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Stock Unit</th>
                                            <td *matCellDef="let row">
                                               {{row.StockUnit}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="PlannedPurchaseDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Planned Purchase Date
                                            </th>
                                            <td *matCellDef="let row">
                                               {{row.PlannedPurchaseDate|date}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="UploadType">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Type</th>
                                            <td *matCellDef="let row">
                                               {{row.UploadType}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="Price">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preferred Price</th>
                                            <td *matCellDef="let row">
                                                {{row.Price}}

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vendor">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preferred Vendor
                                            </th>
                                            <td *matCellDef="let row">
                                              {{row.vendor}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="DateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Creation</th>
                                            <td *matCellDef="let row">
                                              {{row.DateOfCreation|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="AddedByUserId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Added By User Id</th>
                                            <td *matCellDef="let row">
                                             {{row.AddedByUserId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Of Product</th>
                                            <td *matCellDef="let row">
                                                <button (click)="saveOpenOrders(row._id)">Place Order</button>

                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="Actions">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true  && delete!=true && write !=true "
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    didn't have permission for actions</p>

                                                <ul class="list-group list-group-flush"
                                                    *ngIf="write==true || delete==true">
                                                    <li class="list-group-item  friend-list mb-2">
                                                        
                                                        <div class="dropdown show float-right list-block">
                                                            <a class="userDropdown" href="#" role="button"
                                                                style="margin-right: 90px;" id="userDropdown"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                                <button class="dropdown-item" data-toggle="modal"
                                                                    *ngIf="write==true" data-target="#responsive"
                                                                    (click)="getByShoppingCartId(row._id)">
                                                                    <i class="fa fa-address-card"
                                                                        aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</button>

                                                                <button class="dropdown-item"
                                                                    (click)="deleteShoppingCart(row._id)"
                                                                    *ngIf="delete==true">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>

                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator style="margin-right:200px" [length]="100" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>

</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit ShoppingCart Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #shoppingCartUpdate="ngForm" novalidate>
                    <div class="form-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> Account
                                        Id
                                    </label>
                                    <select class="form-control" required #accountId="ngModel" name="accountId"
                                        [(ngModel)]="shoppingCartUpdateObj.accountId" readonly
                                        data-placeholder="Choose a Role Name" tabindex="1"
                                        (change)="getByCurrentInventoryStatusandEmailID(shoppingCartUpdateObj.accountId)">
                                        <option disabled="" value="" selected>Account Id</option>

                                        <option *ngFor="let ual of userAccountsList" value="{{ual._id}}">
                                            {{ual.emailAddress}}</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!accountId.errors.required"
                                        *ngIf="accountId.errors && (accountId.touched || accountId.dirty)">*Please
                                        select Account Id
                                    </span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> Product

                                    </label>
                                    <select class="form-control" required #productId="ngModel" name="productId"
                                        [(ngModel)]="shoppingCartUpdateObj.productId" readonly
                                        data-placeholder="Choose a Role Name" tabindex="1">
                                        <option disabled="" value="" selected>Product Id</option>

                                        <option *ngFor="let cil of currentInventoryList" value="{{cil.productId}}">
                                            {{cil.productName}}</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!productId.errors.required"
                                        *ngIf="productId.errors && (productId.touched || productId.dirty)">*Please
                                        select Product Id
                                    </span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Required Quantity
                                    </label>
                                    <input type="text" id="requiredQuantity" class="form-control" required
                                        maxlength="30" #requiredQuantity="ngModel" name="requiredQuantity"
                                        [(ngModel)]="shoppingCartUpdateObj.requiredQuantity" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        placeholder="requiredQuantity" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!requiredQuantity.errors.required"
                                        *ngIf="requiredQuantity.errors && (requiredQuantity.touched || requiredQuantity.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Planned Purchase
                                        Date
                                    </label>
                                    <input type="date" id="plannedPurchasedate" class="form-control" required  [min]="minDate | date:'yyyy-MM-dd'"
                                        minlength="3" maxlength="30" #plannedPurchasedate="ngModel"
                                        name="plannedPurchasedate" [ngModel]="theDate | date:'yyyy-MM-dd'"
                                        (ngModelChange)="theDate = $event" placeholder="Select Date" maxlength="40">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!plannedPurchasedate.errors.required"
                                        *ngIf="plannedPurchasedate.errors && (plannedPurchasedate.touched || plannedPurchasedate.dirty)">
                                        *This Field is Required</span>

                                </div>
                            </div>

                            <!--/span-->
                        </div>
                        <!--/row-->
                    </div>

                    <!--/row-->






                    <div class="form-actions m-t-40" *ngIf="export==true">
                        <button type="submit" style="background-color: #353556;color:white" data-dismiss="modal"
                            class="btn" (click)="updateShoppingCart()" [disabled]="!shoppingCartUpdate.valid">
                            <i class="fa fa-check"></i> Update</button> &nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_0'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_1'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_2'}}"
                width="100" height="100" />
            </div>
        </div>
    </div>
</div>
